import { render, staticRenderFns } from "./FaceRecognitionManage.vue?vue&type=template&id=effb589c&scoped=true"
import script from "./FaceRecognitionManage.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionManage.vue?vue&type=script&lang=js"
import style0 from "./FaceRecognitionManage.vue?vue&type=style&index=0&id=effb589c&prod&lang=scss&scoped=true"
import style1 from "./FaceRecognitionManage.vue?vue&type=style&index=1&id=effb589c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb589c",
  null
  
)

export default component.exports